import { Result, failure, success } from '../shared'
import { SystemProvider } from './system.provider'
import { SystemActionsProvider } from './systemActions.provider'
import {
  SystemServiceErrorCode,
  SystemInfoServiceResult,
  SystemActiveUsersServerData,
  SystemKickUserServiceFailure,
} from './system.types'
import { SystemActions } from './system.constants'

export class SystemService {
  constructor(private infoProvider: SystemProvider, private actionsProvider: SystemActionsProvider) {}

  public async info(): Promise<Result<SystemInfoServiceResult>> {
    try {
      const { data } = await this.infoProvider.info()
      return success({
        version: [data.Major, data.Minor, data.Build].join('.'),
        date: data.ApplyDate,
      })
    } catch (error) {
      return failure(SystemServiceErrorCode.GENERAL)
    }
  }

  public async activeUsers(): Promise<Result<SystemActiveUsersServerData>> {
    try {
      const { data } = await this.infoProvider.activeUsers()
      return success(data)
    } catch (error) {
      return failure(SystemServiceErrorCode.GENERAL)
    }
  }

  public async kickUser(displayToken: string): Promise<Result<void, SystemKickUserServiceFailure>> {
    try {
      await this.actionsProvider.kick(SystemActions.KickUser, displayToken)
      return success()
    } catch (error) {
      return failure(SystemServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }

  public async kickAllUser(): Promise<Result<void, SystemKickUserServiceFailure>> {
    try {
      await this.actionsProvider.kick(SystemActions.KickAllUser)
      return success()
    } catch (error) {
      return failure(SystemServiceErrorCode.GENERAL, {
        message: error.Message || error.Text,
      })
    }
  }
}
